// // import { useEffect, useState } from "react";
// // import {
// //   MapsComponent,
// //   LayersDirective,
// //   LayerDirective,
// //   MarkersDirective,
// //   MarkerDirective,
// //   Inject,
// //   Marker,
// //   MapsTooltip,
// // } from "@syncfusion/ej2-react-maps";
// // import world_map from "../../../../../../utils/world-map.json";

// // const SkillMap = (props) => {
// //   const { chartsData } = props;
// //   const [locations, setLocations] = useState([]);
// //   const [loading, setLoading] = useState(true);

// //   useEffect(() => {
// //     const locationSet = new Set();
// //     setLocations([]);
// //     const distinctLocations = [];
// //     setLoading(true);

// //     if (chartsData && chartsData.length > 0) {
// //       chartsData.forEach((entry) => {
// //         entry.skills.forEach((skill) => {
// //           skill.location.forEach((loc) => {
// //             const key = `${loc.lat},${loc.long}`;
// //             if (!locationSet.has(key)) {
// //               locationSet.add(key);
// //               distinctLocations.push({
// //                 latitude: loc.lat,
// //                 longitude: loc.long,
// //                 locationName: `Lat: ${loc.lat}, Lon: ${loc.long}`, // Optional default name
// //               });
// //             }
// //           });
// //         });
// //       });

// //       // Delay ensures map is ready (important in Syncfusion maps)
// //       fetchLocations(distinctLocations);
// //     } else {
// //       setLocations([]);
// //       setLoading(false);
// //     }
// //   }, [chartsData]);

// //   const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// //   // Fetch location names only once
// //   const fetchLocations = async (distinctLocation) => {
// //     try {
// //       const updatedLocations = [];

// //       for (let i = 0; i < distinctLocation.length; i++) {
// //         const loc = distinctLocation[i];
// //         const locationName = await getLocationName(loc.latitude, loc.longitude);
// //         updatedLocations.push({ ...loc, locationName });

// //         // Add 1 second delay before next request
// //         if (i < distinctLocation.length - 1) {
// //           await delay(1000);
// //         }
// //       }

// //       setLocations(updatedLocations);
// //     } catch (error) {
// //       console.error("Error fetching locations:", error);
// //       setLocations([]);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   // Function to fetch location name from coordinates
// //   async function getLocationName(lat, lon) {
// //     try {
// //       const res = await fetch(
// //         `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`
// //       );
// //       const data = await res.json();
// //       return (
// //         data?.address?.city ||
// //         data?.address?.town ||
// //         data?.address?.country ||
// //         "Unknown"
// //       );
// //     } catch (error) {
// //       return "Unknown";
// //     }
// //   }

// //   return (
// //     <div className="chart-display-width">
// //       <h3>Users Geolocation</h3>

// //       {loading ? (
// //         <div className="loader-map">
// //           <div className="loader-wrap">
// //             <div className="loader-dot loader-dot1"></div>
// //             <div className="loader-dot loader-dot2"></div>
// //             <div className="loader-dot loader-dot3"></div>
// //             <div className="loader-dot loader-dot4"></div>
// //             <div className="loader-text loader-map-text-display ">
// //               Loading locations...
// //             </div>
// //           </div>
// //         </div>
// //       ) : locations.length > 0 ? (
// //         <MapsComponent
// //           clusterSettings={{
// //             allowClustering: false, // Set to true if you want clustering
// //             shape: "Circle",
// //             height: 40,
// //             width: 40,
// //             labelStyle: { color: "white" },
// //           }}
// //         >
// //           <Inject services={[Marker, MapsTooltip]} />
// //           <LayersDirective>
// //             <LayerDirective shapeData={world_map}>
// //               <MarkersDirective>
// //                 {locations.map((loc, index) => (
// //                   <MarkerDirective
// //                     key={index}
// //                     visible={true}
// //                     latitudeValuePath="latitude"
// //                     longitudeValuePath="longitude"
// //                     shape="Circle"
// //                     width={6}
// //                     height={6}
// //                     dataSource={[loc]}
// //                     tooltipSettings={{
// //                       visible: true,
// //                       valuePath: "locationName",
// //                       template: "<div>📍 ${locationName}</div>",
// //                     }}
// //                   />
// //                 ))}
// //               </MarkersDirective>
// //             </LayerDirective>
// //           </LayersDirective>
// //         </MapsComponent>
// //       ) : (
// //         <div className="container-no-records">No Records Found</div>
// //       )}
// //     </div>
// //   );
// // };

// // export default SkillMap;

// // import { useEffect, useState } from "react";
// // import {
// //   MapsComponent,
// //   LayersDirective,
// //   LayerDirective,
// //   MarkersDirective,
// //   MarkerDirective,
// //   Inject,
// //   Marker,
// //   MapsTooltip,
// // } from "@syncfusion/ej2-react-maps";
// // import world_map from "../../../../../../utils/world-map.json";

// // const SkillMap = (props) => {
// //   const { chartsData } = props;
// //   const [locations, setLocations] = useState([]);
// //   const [loading, setLoading] = useState(true);

// //   useEffect(() => {
// //     const locationSet = new Set();
// //     setLocations([]);
// //     const distinctLocations = [];
// //     setLoading(true);

// //     if (chartsData && chartsData.length > 0) {
// //       chartsData.forEach((entry) => {
// //         entry.skills.forEach((skill) => {
// //           skill.location.forEach((loc) => {
// //             const key = `${loc.lat},${loc.long}`;
// //             if (!locationSet.has(key)) {
// //               locationSet.add(key);
// //               distinctLocations.push({
// //                 latitude: loc.lat,
// //                 longitude: loc.long,
// //                 locationName: `Lat: ${loc.lat}, Lon: ${loc.long}`, // Fallback
// //               });
// //             }
// //           });
// //         });
// //       });

// //       fetchLocations(distinctLocations);
// //     } else {
// //       setLocations([]);
// //       setLoading(false);
// //     }
// //   }, [chartsData]);

// //   // Fetch all locations using BigDataCloud API
// //   const fetchLocations = async (distinctLocation) => {
// //     try {
// //       const updatedLocations = [];

// //       for (let i = 0; i < distinctLocation.length; i++) {
// //         const loc = distinctLocation[i];
// //         const locationName = await getLocationName(loc.latitude, loc.longitude);
// //         updatedLocations.push({ ...loc, locationName });

// //         // Small delay (optional, keeps requests smooth)
// //         if (i < distinctLocation.length - 1) {
// //           await delay(1000);
// //         }
// //       }

// //       setLocations(updatedLocations);
// //     } catch (error) {
// //       console.error("Error fetching locations:", error);
// //       setLocations([]);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// //   // Function to fetch location name from coordinates
// //   async function getLocationName(lat, lon) {
// //     try {
// //       const res = await fetch(
// //         `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${lat}&longitude=${lon}&localityLanguage=en`
// //       );
// //       const data = await res.json();
// //       return (
// //         data.city ||
// //         data.locality ||
// //         data.principalSubdivision ||
// //         data.countryName ||
// //         "Unknown"
// //       );
// //     } catch (error) {
// //       return "Unknown";
// //     }
// //   }

// //   return (
// //     <div className="chart-display-width">
// //       <h3>Users Geolocation</h3>

// //       {loading ? (
// //         <div className="loader-map">
// //           <div className="loader-wrap">
// //             <div className="loader-dot loader-dot1"></div>
// //             <div className="loader-dot loader-dot2"></div>
// //             <div className="loader-dot loader-dot3"></div>
// //             <div className="loader-dot loader-dot4"></div>
// //             <div className="loader-text loader-map-text-display">
// //               Loading locations...
// //             </div>
// //           </div>
// //         </div>
// //       ) : locations.length > 0 ? (
// //         <MapsComponent>
// //           <Inject services={[Marker, MapsTooltip]} />
// //           <LayersDirective>
// //             <LayerDirective shapeData={world_map}>
// //               <MarkersDirective>
// //                 {locations.map((loc, index) => (
// //                   <MarkerDirective
// //                     key={index}
// //                     visible={true}
// //                     latitudeValuePath="latitude"
// //                     longitudeValuePath="longitude"
// //                     shape="Circle"
// //                     width={6}
// //                     height={6}
// //                     dataSource={[loc]}
// //                     tooltipSettings={{
// //                       visible: true,
// //                       valuePath: "locationName",
// //                       template: "<div>📍 ${locationName}</div>",
// //                     }}
// //                   />
// //                 ))}
// //               </MarkersDirective>
// //             </LayerDirective>
// //           </LayersDirective>
// //         </MapsComponent>
// //       ) : (
// //         <div className="container-no-records">No Records Found</div>
// //       )}
// //     </div>
// //   );
// // };

// // export default SkillMap;

// import {
//   MapsComponent,
//   LayersDirective,
//   LayerDirective,
//   MarkersDirective,
//   MarkerDirective,
//   Inject,
//   Marker,
//   MapsTooltip,
// } from "@syncfusion/ej2-react-maps";
// import world_map from "../../../../../../utils/world-map.json";
// import { useState } from "react";
// import ErrorBoundary from "../../../../../../helper/shared/mapErrorBoundary";

// const SkillMap = ({ setRetryKey, locations = [] }) => {

//   return (
//     <div className="chart-display-width">
//       <h3>Users Geolocation</h3>

//       {locations.length > 0 ? (
//         <ErrorBoundary onRetry={() => setRetryKey((prev) => prev + 1)}>
//           <MapsComponent>
//             <Inject services={[Marker, MapsTooltip]} />
//             <LayersDirective>
//               <LayerDirective shapeData={world_map}>
//                 <MarkersDirective>
//                   <MarkerDirective
//                     visible={true}
//                     shape="Circle"
//                     width={6}
//                     height={6}
//                     dataSource={locations}
//                     latitudeValuePath="latitude"
//                     longitudeValuePath="longitude"
//                     tooltipSettings={{
//                       visible: true,
//                       valuePath: "tooltipText", // always a string
//                     }}
//                   />
//                 </MarkersDirective>
//               </LayerDirective>
//             </LayersDirective>
//           </MapsComponent>
//         </ErrorBoundary>
//       ) : (
//         <div className="container-no-records">No Records Found</div>
//       )}
//     </div>
//   );
// };

// export default SkillMap;

import {
  MapsComponent,
  LayersDirective,
  LayerDirective,
  MarkersDirective,
  MarkerDirective,
  Inject,
  Marker,
  MapsTooltip,
} from "@syncfusion/ej2-react-maps";
import world_map from "../../../../../../utils/world-map.json";
import ErrorBoundary from "../../../../../../helper/shared/mapErrorBoundary";

const originalMarkerClick = Marker.prototype.markerClick;
Marker.prototype.markerClick = function (...args) {
  try {
    return originalMarkerClick.apply(this, args);
  } catch (err) {
    console.warn("Suppressed Syncfusion markerClick error:", err);
    return null;
  }
};

const SkillMap = ({ setRetryKey, locations = [] }) => {
  const safeLocations = (locations || [])
    .filter(
      (l) =>
        l && typeof l.latitude === "number" && typeof l.longitude === "number"
    )
    .map((l) => ({
      ...l,
      tooltipText:
        typeof l.tooltipText === "string" && l.tooltipText.trim()
          ? l.tooltipText
          : `Lat: ${l.latitude}, Lon: ${l.longitude}`,
    }));

  return (
    <div className="chart-display-width">
      <h3>Users Geolocation</h3>
      {safeLocations.length > 0 ? (
        <ErrorBoundary onRetry={() => setRetryKey((prev) => prev + 1)}>
          <MapsComponent>
            <Inject services={[Marker, MapsTooltip]} />
            <LayersDirective>
              <LayerDirective shapeData={world_map}>
                <MarkersDirective>
                  <MarkerDirective
                    visible={true}
                    shape="Circle"
                    width={6}
                    height={6}
                    dataSource={safeLocations}
                    latitudeValuePath="latitude"
                    longitudeValuePath="longitude"
                    tooltipSettings={{
                      visible: true,
                      valuePath: "tooltipText",
                    }}
                  />
                </MarkersDirective>
              </LayerDirective>
            </LayersDirective>
          </MapsComponent>
        </ErrorBoundary>
      ) : (
        <div className="container-no-records">No Records Found</div>
      )}
    </div>
  );
};

export default SkillMap;
